/**
 * @group Data
 * @summary Role management actions
 * 
 * @remarks
 * This constant contains action names used in role management operations,
 * specifically for permission assignment and removal.
 * 
 * @example
 * ```typescript
 * import { ROLE_ACTIONS } from '@shared/constants';
 * 
 * switch (action) {
 *   case ROLE_ACTIONS.ADD_PERMISSION:
 *     return await addPermissionToRole(roleId, permissionId);
 *   case ROLE_ACTIONS.REMOVE_PERMISSION:
 *     return await removePermissionFromRole(roleId, permissionId);
 * }
 * ```
 */
export const ROLE_ACTIONS = {
  ADD_PERMISSION: 'addPermission',
  REMOVE_PERMISSION: 'removePermission'
} as const; 